import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, AppleIcon, StethoscopeIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpenIcon,
    badge: '🌱 EDUCACIÓN',
    title: 'Beca Semilla',
    description: 'Educación para padres, recursos, talleres y programas de formación para fortalecer el conocimiento familiar',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400'
  }, {
    icon: AppleIcon,
    badge: '💚 SALUD',
    title: 'Beca Crecer',
    description: 'Acceso a consultas con especialistas, evaluaciones, estudios complementarios y segundas opiniones',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400'
  }, {
    icon: StethoscopeIcon,
    badge: '🤝 COMUNIDAD',
    title: 'Alianzas Estratégicas',
    description: 'Trabajo conjunto con médicos, terapeutas y organizaciones para ampliar el acceso a servicios de calidad',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400'
  }];
  return <section className="mp-becas-section" style={{
    background: 'linear-gradient(180deg, #f0fae8 0%, white 100%)',
    padding: '80px 20px'
  }} data-id="element-187" data-mp="3b9yyqtdgr9h3">
      <div className="max-w-6xl mx-auto" data-id="element-188" data-mp="3kb6kkbysmhua">
        <p style={{
        color: '#7DC920',
        fontSize: '12px',
        letterSpacing: '3px',
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: '8px'
      }} data-id="element-189" data-mp="3k80w8yxznjzm">
          NUESTROS PROGRAMAS
        </p>
        <h2 className="mp-becas-title" style={{
        fontSize: '38px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-190" data-mp="2w03xv289u56">
          Becas y Programas de Apoyo
        </h2>
        <p style={{
        fontSize: '16px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '48px',
        maxWidth: '640px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }} data-id="element-191" data-mp="gty7e5f0g65w">
          Diseñados para eliminar las barreras económicas que enfrentan las
          familias con niños neurodiversos
        </p>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-192" data-mp="2htt91rr8untf">
          {features.map(feature => <div key={feature.title} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" style={{
          borderTop: '4px solid #7DC920'
        }} data-id="element-193" data-mp="2vlhni1oytodk">
              <img src={feature.image} alt={feature.title} className="w-full h-[200px] object-cover" data-id="element-194" data-mp="30mx9px2vq0xj" />
              <div className="p-8" data-id="element-195" data-mp="1696190wadn3o">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6" data-id="element-196" data-mp="16a7cb5day9le">
                  <feature.icon className="w-8 h-8 text-primary" data-id="element-197" data-mp="3hy2egtm37bn4" />
                </div>
                <div style={{
              background: '#e8f5e0',
              color: '#2d5a1b',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '2px',
              padding: '4px 10px',
              borderRadius: '20px',
              display: 'inline-block',
              marginBottom: '8px'
            }} data-id="element-198" data-mp="3mwvtwrkxpcpx">
                  {feature.badge}
                </div>
                <h3 className="text-xl text-dark mb-3" style={{
              fontWeight: 800
            }} data-id="element-199" data-mp="2p9f07hzr9mj2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-200" data-mp="sfahr5pyy4u2">{feature.description}</p>
                <Link to="/solicitar-ayuda" style={{
              color: '#7DC920',
              fontWeight: 600,
              fontSize: '14px',
              textDecoration: 'none'
            }} data-id="element-201" data-mp="scegb7ewwy0v">
                  Conocer más →
                </Link>
              </div>
            </div>)}
        </div>

        <div className="mp-becas-box" style={{
        background: '#2d5a1b',
        borderRadius: '16px',
        padding: '32px 40px',
        maxWidth: '800px',
        margin: '40px auto 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px'
      }} data-id="element-202" data-mp="25j187jgxma43">
          <div data-id="element-203" data-mp="1rpthrv4l7knz">
            <p style={{
            fontSize: '22px',
            fontWeight: 700,
            color: 'white',
            marginBottom: '6px'
          }} data-id="element-204" data-mp="1msa2crw5l1ug">
              ¿Tu familia necesita apoyo?
            </p>
            <p style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.8)'
          }} data-id="element-205" data-mp="17p9ylskiryvn">
              Estamos construyendo nuestro programa oficial de becas.
            </p>
          </div>
          <Link to="/solicitar-ayuda" className="mp-becas-box-btn" style={{
          background: '#7DC920',
          color: 'white',
          fontWeight: 700,
          padding: '14px 28px',
          borderRadius: '10px',
          whiteSpace: 'nowrap',
          textDecoration: 'none'
        }} data-id="element-206" data-mp="1mn2g2q9mmxch">
            Solicitar Ayuda →
          </Link>
        </div>

        <div className="text-center" style={{
        marginTop: '40px'
      }} data-id="element-207" data-mp="13p9crmv3clek">
          <p className="text-2xl font-bold text-dark max-w-3xl mx-auto" data-id="element-208" data-mp="67hpw1vi2ax6">
            Becas, alianzas y apoyo financiero para que ninguna familia quede
            sola.
          </p>
        </div>
      </div>
    </section>;
}